import React, { useState, useEffect} from 'react'

export default function FullscreenBtn(props) {
        const [iconClass, setIconClass] = useState("fa fa-expand")

        useEffect(() => {
                document.getElementById(props.element_id).addEventListener('fullscreenchange', () => {
                        if (document.fullscreenElement) {
                                setIconClass("fa fa-compress")
                        } else {
                                setIconClass("fa fa-expand")
                        }
                });
        });

        function change_screen() {
                if (document.fullscreenElement) {
                        document.exitFullscreen();
                } 
                else {
                        document.getElementById(props.element_id).requestFullscreen();
                }
        }

        return (
                <button onClick={() => { change_screen() }} className="btn btn-primary mr-3" style={{fontSize: "15px", color: "white"}}><i className={iconClass}></i></button>
        )
}
